module.exports = __webpack_public_path__ + "deae95b877d0d9d13d83a8301f1e1de8.png";